const config = require('./config.json');
const annee1 = require('./annee1.json');
const annee2 = require('./annee2.json');
const annee3 = require('./annee3.json');

if (!config.routes) config.routes = [];
config.routes = config.routes.concat([annee1, annee2, annee3]);


module.exports = [annee1, annee2, annee3];
